export const NON_BRAKING_SPACE = '\u00A0'

export default NON_BRAKING_SPACE
